import { DialogContent } from '~/shared/components/Dialog/DialogContent';
import { Text } from '~/shared/components/Text/Text';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';

import styles from './marketSelectorDialogContent.module.css';

import { MarketSelector } from '../MarketSelector/MarketSelector';

export const MarketSelectorDialogContent = () => {
	const { translate } = useTranslation();
	return (
		<DialogContent className={styles.root}>
			<Text
				as="h3"
				variant="display3"
			>
				{translate('market-selector.select-your-location')}
			</Text>
			<MarketSelector />
		</DialogContent>
	);
};
